module.exports = __webpack_public_path__ + "img/s2.0c375649.png";